import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { ModalProvider } from '../_metronic/layout/core/ModalProvider'
import { AuthInit } from './modules/auth'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <ModalProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              {/* <SystemPreferencesProviderInit /> */}
              <MasterInit />
            </AuthInit>
          </LayoutProvider>
        </ModalProvider>
      </I18nProvider>
    </Suspense>
  )
}

export { App }
